import { useEffect, useState } from 'react';
import { isValidEmail } from '../../func.ts';
import M from 'materialize-css';
import ConfirmationModal from './ConfirmationModal.tsx';
import userMutationHooks from '../../common/mutationHooks/userMutationHooks.ts';

const ChangeUserInfo = ({ user }) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [originalEmailAddress, setOriginalEmailAddress] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [passValidation, setPassValidation] = useState(false);

  const { mutate: submit, isPending } =
    userMutationHooks.useCreateEmailAddressToken();

  const onChange = ({ target: { id, value } }) => setEmailAddress(p => value);

  useEffect(() => {
    setPassValidation(isValidEmail(emailAddress));
    M.updateTextFields();
  }, [emailAddress]);

  useEffect(() => {
    if (!emailAddress && !!user) {
      const email = user?.auth?.emailAddress;
      setEmailAddress(email);
      setOriginalEmailAddress(email);
    }
  }, [user, emailAddress]);

  return (
    <div>
      <div className="row">
        <div className="input-field col s12 m4">
          <input
            id="emailAddress"
            type={'text'}
            value={emailAddress}
            onChange={onChange}
          />
          <label htmlFor="emailAddress">Email Address</label>
        </div>
      </div>

      <div className="row" style={{ marginTop: '40px' }}>
        <button
          className="btn btn-small blue white-text waves-effect waves-light col s12 m4 l2"
          onClick={e => {
            e.preventDefault();
            submit({ emailAddress });
            setIsOpen(true);
          }}
          disabled={!passValidation || isPending}
        >
          Save
        </button>
      </div>
      <ConfirmationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        resendTotp={submit}
        submitIsPending={isPending}
        emailAddress={emailAddress}
        originalEmailAddress={originalEmailAddress}
      />
    </div>
  );
};

export default ChangeUserInfo;
